//const baseUrl = 'http://alpha-03.trizentinc.com:40080/empats/uat';
// const baseUrl = 'https://alpha-03.trizentinc.com/empats/uat';
const baseUrl = `https://alpha-03.trizentinc.com/empats/uat`

export default baseUrl;